import * as React from "react";
const LocationGreySvg = (props) => (
  <svg
    width={10}
    height={13}
    viewBox="0 0 10 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.8125 0C3.53659 0.00144743 2.31335 0.508942 1.41115 1.41115C0.508942 2.31335 0.00144743 3.53659 0 4.8125C0 8.93047 4.375 12.0405 4.56148 12.1707C4.63505 12.2222 4.72268 12.2499 4.8125 12.2499C4.90232 12.2499 4.98995 12.2222 5.06352 12.1707C5.25 12.0405 9.625 8.93047 9.625 4.8125C9.62355 3.53659 9.11606 2.31335 8.21385 1.41115C7.31165 0.508942 6.08841 0.00144743 4.8125 0ZM4.8125 3.0625C5.15862 3.0625 5.49696 3.16514 5.78475 3.35743C6.07253 3.54972 6.29684 3.82303 6.42929 4.1428C6.56174 4.46257 6.5964 4.81444 6.52887 5.15391C6.46135 5.49337 6.29468 5.8052 6.04994 6.04994C5.80519 6.29468 5.49337 6.46135 5.15391 6.52887C4.81444 6.5964 4.46257 6.56174 4.1428 6.42929C3.82303 6.29684 3.54972 6.07253 3.35743 5.78475C3.16514 5.49696 3.0625 5.15862 3.0625 4.8125C3.0625 4.34837 3.24687 3.90325 3.57506 3.57506C3.90325 3.24687 4.34837 3.0625 4.8125 3.0625Z"
      fill="#676C6F"
    />
  </svg>
);
export default LocationGreySvg;
